import { AddRoadOutlined, DirectionsRailwayOutlined, HolidayVillageOutlined, PictureInPictureOutlined, WaterOutlined } from "@mui/icons-material";
import { Feature, Geometry } from "geojson";

import { lineStringDrawingConfig, pointDrawingConfig, polygonDrawingConfig, ToolbarConfig } from "fond/map/Toolbar";
import { ISGLayerId, ISGLayerIds } from "fond/types";
import { isAnyLineString, isAnyPoint, isAnyPolygon } from "fond/types/geojson";
import SvgIcon from "fond/widgets/SvgIcon";

export interface ISGLayerConfig {
  key: ISGLayerId;
  title: string;
  icon: React.ReactElement;
  isRequired?: boolean;
  displayName: string;
  navigationKey: string;
  geometryType: "Point" | "LineString" | "Polygon";
  drawingConfig: ToolbarConfig;
  filterFeatures: (feature: Feature<Geometry>) => boolean;
  combineToMultiPolygon?: boolean;
  group: "Base data" | "Reference layers";
}

export const isgInputLayers: ISGLayerConfig[] = [
  {
    key: ISGLayerIds.boundary,
    title: "Boundary",
    displayName: "Boundary",
    navigationKey: "boundary",
    icon: <SvgIcon icon="polygon" />,
    isRequired: true,
    geometryType: "Polygon",
    drawingConfig: polygonDrawingConfig,
    filterFeatures: isAnyPolygon,
    combineToMultiPolygon: true,
    group: "Base data",
  },
  {
    key: ISGLayerIds.address,
    title: "Address",
    displayName: "Addresses",
    navigationKey: "address",
    icon: <HolidayVillageOutlined />,
    isRequired: true,
    geometryType: "Point",
    drawingConfig: pointDrawingConfig,
    filterFeatures: isAnyPoint,
    group: "Base data",
  },
  {
    key: ISGLayerIds.parcels,
    title: "Parcels",
    displayName: "Parcels",
    navigationKey: "parcel",
    icon: <PictureInPictureOutlined />,
    geometryType: "Polygon",
    drawingConfig: polygonDrawingConfig,
    filterFeatures: isAnyPolygon,
    group: "Base data",
  },
  {
    key: ISGLayerIds.streets,
    title: "Streets",
    displayName: "Streets",
    navigationKey: "street",
    icon: <AddRoadOutlined />,
    geometryType: "LineString",
    drawingConfig: lineStringDrawingConfig,
    filterFeatures: isAnyLineString,
    group: "Base data",
  },
  {
    key: ISGLayerIds.waterways,
    title: "Waterways",
    displayName: "Waterways",
    navigationKey: "waterway",
    icon: <WaterOutlined />,
    geometryType: "LineString",
    drawingConfig: lineStringDrawingConfig,
    filterFeatures: isAnyLineString,
    group: "Reference layers",
  },
  {
    key: ISGLayerIds.railways,
    title: "Railways",
    displayName: "Railways",
    navigationKey: "railway",
    icon: <DirectionsRailwayOutlined />,
    geometryType: "LineString",
    drawingConfig: lineStringDrawingConfig,
    filterFeatures: isAnyLineString,
    group: "Reference layers",
  },
];
